export default __webpack_public_path__ + "static/media/PS5-DE-3.0173cc28.jpg";